import React, { FC } from 'react';
import cls from './Select.module.scss';
import { Option, OptionValue } from './types';
import DivCalcTooltip from 'src/components/UI/DivCalcTooltip/DivCalcTooltip';
import Tooltip from '../../components/UI/Tooltip/Tooltip';

interface DropdownItemEntryProps {
  option: Option;
  selectValue: (value: OptionValue, event?: React.MouseEvent) => void;
  hoveredElementKey: string | number | null | undefined;
  setHoveredElementKey: (value: string | number | null | undefined) => void;
}
const DropdownItemEntry: FC<DropdownItemEntryProps> = ({
  option,
  selectValue,
  hoveredElementKey,
  setHoveredElementKey,
}) => {
  return (
    <div
      onMouseEnter={() => {
        setHoveredElementKey(option.key || option.value);
      }}
      onMouseLeave={() => {
        setHoveredElementKey(undefined);
      }}
      data-qa-selector={option.title}
      className={cls['option']}
      onClick={(event) => {
        selectValue(option.value, event);
      }}
    >
      {option.element && (
        <div className={cls['option-element']}>{option.element}</div>
      )}
      <Tooltip title={option?.tooltipTitle || ''} placement="right">
        {option?.title && (
          <div
            className={`${cls['option-title']} ${option.titleClassName || ''}`}
          >
            <DivCalcTooltip
              text={option.title}
              placement="right"
              hoveredElementKey={hoveredElementKey}
            />
          </div>
        )}
      </Tooltip>
    </div>
  );
};
export default DropdownItemEntry;
